import React from 'react';

const styles = {
    tablecellpadding: {
        padding: '1.5em 0'
    }
}

const DeleteDonationFile = (props) => {
    if(props.currentDonation && props.user.type==="admin") {
        return (
            <a onClick={() => { if (window.confirm('Filen vil blive slettet permanent. Ønsker du at fortsætte?')) props.handleDeleteFileFromServer()}} style={{cursor: 'pointer'}}>
                <img alt="Slet bilag vedr. donationer" src="/images/assets/kryds.svg" title="Slet bilag vedr. donationer" />
            </a>
        )
    } else {
        return null;
    }
}

export default DeleteDonationFile;


// WEBPACK FOOTER //
// ./src/modules/reports/DeleteDonationsFile.js